export const categories = [
  { id: 1, label: "Software Developer" },
  { id: 2, label: "Front End Developer" },
  { id: 3, label: "Engineering Manager" },
  { id: 4, label: "Mobile App Developer" },
  { id: 5, label: "Technical Lead" },
  { id: 6, label: "DevOps Engineer" },
  { id: 7, label: "Product Manager" },
];

export const jobsTypes = [
  { id: 1, label: "Full Time" },
  { id: 2, label: "Part Time" },
  { id: 3, label: "Contract" },
  { id: 4, label: "Internship" },
  { id: 5, label: "Remote" },
];
